module.exports = __webpack_public_path__ + "static/media/loginBackground.a9854983.PNG";